import { Card, TruncatedText } from "@carbon6/c6-frontend-design";
import { StatusChip } from "@/shared/ui/status";
import { formatDateTime } from "@/shared/utils/datetime/format";
import { formatSourceKind } from "../../feature/datasetFormatters";
import type { DatasetTableRow } from "../DatasetTableRow";
import { LatestProbeChip } from "./LatestProbeChip";
import styles from "./DatasetCard.module.css";

type DatasetCardProps = {
  row: DatasetTableRow;
};

/**
 * Datasets 그리드의 카드 — 표의 한 행이 말하는 것을 그대로 카드로 말한다.
 *
 * 클릭 활성화는 `DataGridView` 의 아이템 래퍼가 소유하므로(`isRowClickable`) 카드에 `onClick` 을 주지
 * 않는다(이중화 방지, c6 `Card` 계약). 우상단은 읽기 전용 상태(숨김 칩)와 행 액션 메뉴의 자리다.
 * 섬네일 소스가 아직 없어 `Card.Media` 는 두지 않는다.
 */
export function DatasetCard({ row }: DatasetCardProps) {
  return (
    <Card
      layout="vertical"
      variant="outlined"
      className={styles.card}
      aria-label={row.displayName}
      data-kind="dataset"
    >
      <Card.Header
        title={<TruncatedText>{row.displayName}</TruncatedText>}
        actions={
          <div className={styles.actions}>
            {row.isHidden ? <StatusChip tone="muted">숨김</StatusChip> : null}
            {row.hasRowActions ? row.renderRowActions() : null}
          </div>
        }
      />
      <Card.Body>
        {/* 키는 sunken 배경 칩으로 그려 값과 시각적으로 갈린다. 원본 주소는 전폭, 나머지는 반폭 둘씩. */}
        {/* Probe 는 등록 시각 다음 줄의 반폭이다. 상태 칩이라 값 칸의 말줄임을 받지 않는다. */}
        <dl className={styles.metaList}>
          <div title={row.sourceRef}>
            <dt>원본 주소</dt>
            <dd>{row.sourceRef}</dd>
          </div>
          <div data-span="half">
            <dt>종류</dt>
            <dd>{formatSourceKind(row.sourceKind)}</dd>
          </div>
          <div data-span="half">
            <dt>등록 시각</dt>
            <dd>{formatDateTime(row.createdAtMs)}</dd>
          </div>
          <div data-span="half">
            <dt>Probe</dt>
            <dd>
              <LatestProbeChip probe={row.latestProbe} />
            </dd>
          </div>
        </dl>
      </Card.Body>
    </Card>
  );
}
